import { render } from "./ProdutosFracionados.vue?vue&type=template&id=4c0ffc92&scoped=true&ts=true"
import script from "./ProdutosFracionados.vue?vue&type=script&lang=ts"
export * from "./ProdutosFracionados.vue?vue&type=script&lang=ts"

import "./ProdutosFracionados.vue?vue&type=style&index=0&id=4c0ffc92&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c0ffc92"]])

export default __exports__